import { StyleSheet } from 'react-native';

const baseStyles = {
    container: {
        flexGrow: 1,
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'stretch',
        marginTop: 40
    }
};

export default StyleSheet.create(baseStyles);
